import styled, { css } from 'styled-components';

export type StyledFilterProps = {
  flexBasis?: string;
  flex?: number;
};

const Container = styled.div`
  padding-bottom: 2rem;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Filters = styled.div`
  display: flex;
  flex-direction: column;
`;

const FilterContainer = styled.div<{ isCentered?: boolean }>`
  display: flex;

  align-items: ${({ isCentered }) => isCentered && 'center'};

  gap: 2rem;
  margin: 1rem 0;
`;

const Filter = styled.div<StyledFilterProps>`
  flex-basis: ${({ flexBasis }) => flexBasis || '100%'};
  ${({ flex }) =>
    flex
      ? css`
          flex: ${flex};
        `
      : null}
`;

const Buttons = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 2rem;
  flex: 1;
`;

export { Container, Header, Filters, FilterContainer, Filter, Buttons };
